const SITE_HOSTNAMES = new Set(['cdipremium.com.br', 'preview-cdipremium.pages.dev']);

function normalizedHostname(hostname = '') {
  return String(hostname).toLowerCase().replace(/^www\./, '');
}

function currentPageUrl() {
  return typeof window !== 'undefined' ? window.location.href : '';
}

function isInternalHttpUrl(target, pageUrl) {
  const targetHostname = normalizedHostname(target.hostname);
  if (SITE_HOSTNAMES.has(targetHostname)) return true;
  if (!pageUrl) return false;

  try {
    return targetHostname === normalizedHostname(new URL(pageUrl).hostname);
  } catch {
    return false;
  }
}

/**
 * Detecta o tipo de link externo com base na URL.
 * Retorna null para links internos (não rastreáveis).
 */
export function detectExitType(url, pageUrl = currentPageUrl()) {
  if (!url || typeof url !== 'string') return null;
  const value = url.trim();
  const lowerValue = value.toLowerCase();
  if (lowerValue.startsWith('tel:')) return 'telefone';
  if (lowerValue.startsWith('mailto:')) return 'email';

  let target;
  try {
    target = new URL(value, pageUrl || undefined);
  } catch {
    return null;
  }

  const hostname = normalizedHostname(target.hostname);
  if (hostname === 'api.whatsapp.com' || hostname === 'wa.me') return 'whatsapp';
  if (target.protocol !== 'http:' && target.protocol !== 'https:') return null;
  if (isInternalHttpUrl(target, pageUrl)) return null;
  return 'link_externo';
}

export function anonymizeExitDestination(value) {
  const input = String(value || '').trim();
  try {
    const url = new URL(input, 'https://cdipremium.com.br');
    if (url.protocol === 'http:' || url.protocol === 'https:') return `${url.origin}${url.pathname}`;
    if (['tel:', 'mailto:', 'whatsapp:'].includes(url.protocol)) return url.protocol;
  } catch {}
  return 'external:';
}
